import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icons/Icon';

const ScrollButton = ({
  onClick,
  direction = 'left',
  isDisabled = false,
}) => {
  const disabledClasses = 'opacity-50 cursor-not-allowed';
  return (
    <button
      type="button"
      className={`w-6 flex-shrink-0 ${isDisabled && disabledClasses}`}
      onClick={onClick}
      aria-label={`scroll ${direction}`}
      disabled={isDisabled}
    >
      <Icon name={direction === 'left' ? 'expand_left' : 'expand_right'} className="w-6" />
    </button>
  );
};

ScrollButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  direction: PropTypes.oneOf(['left', 'right']),
  isDisabled: PropTypes.bool,
};

export default ScrollButton;
